import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {

  @Input() public color: string = 'transparent';
  @HostBinding('class.selected')
  @Input() public selected: boolean = false;
  @Input() public exterior: string = '';
  @Input() public skin: string = '';
  @Input() public weapon: string = '';
  @Input() public box: string = '';
  @Input() public name: string = '';
  @Input() public statuses: string[] = [];
  @Input() public price: number = 0;
  @Input() public id: number = 0;
  @Input() public enabled: boolean = true;
  @Input() public status: string | null = null;
  @Input() public nextStatusAt: any;
  @HostBinding('attr.style')
  public get valueAsStyle (): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(`--rarity-color: ${this.color}`);
  }

  constructor (
    public readonly sanitizer: DomSanitizer,
  ) {
  }


  ngOnInit(): void {
  }


  public getItemExterior (exterior: string): string {
    const dictionary: Record<string, string> = {
      'Factory New': 'FN',
      'Field-Tested': 'FT',
      'Well-Worn': 'WW',
      'Minimal Wear': 'MW',
      'Battle-Scarred': 'BS',
    };
    return dictionary[exterior];
  }

}
